import { useState } from "react";
import { useSolution } from "../../../../contexts/SolutionsContext";
import MultiSelectDropdown from "../../../Atoms/DropDowns/MultiSelectDropdown";
import IconAndText from "../../../Atoms/IconAndText";
import { NO_AGENT_ERROR } from "../../../../utils/constants";
import "../../css/def.sol.agent.css";
import { CircularProgress } from "@mui/material";

const DefineSolAgent = ({ sno = 2 }) => {
  const {
    ongoingSolutionData,
    updateOngoingSolDataL1,
    validateRequiredField,
    isLoadingAgents,
    agentsForSol,
  } = useSolution();
  const [showNoAgentError, setShowNoAgentError] = useState(false);

  const handleAgentSelection = (selectedAgents) => {
    updateOngoingSolDataL1("agents", selectedAgents);
    validateRequiredField("agents", selectedAgents);

    if (selectedAgents.length > 0) {
      setShowNoAgentError(false);
    }
  };

  return (
    <article className="define-sol-agent mb-5">
      <div id="define-sol-agent" className="mb-2">
        <IconAndText
          text="Define Agent"
          clsNames="mas-icon-txt mb-2"
          iconBefore={<div>{sno}</div>}
        />
      </div>

      {/* No Agent Found Error - Only show when search yields no results */}
      {showNoAgentError && (
        <section className="wd-100 mt-3 mb-3 no-agent-err">
          <p>{NO_AGENT_ERROR.title}</p>
          <ol>
            {NO_AGENT_ERROR?.steps?.map((step, index) => {
              return <li key={index}>{step}</li>;
            })}
          </ol>
        </section>
      )}

      <section className="d-flex mx-wd-100 gp-x-16">
        <div className="wd-50">
          <label className="mas-form-label-regular">
            {"Agent Name"}
            <span className="marketplace-req-asterik">*</span>
          </label>
          <div className="d-flex align-items-center">
            <MultiSelectDropdown
              selectValues={
                agentsForSol?.map((agent) => ({
                  label: agent?.agent_name,
                  value: agent?.agent_id,
                })) || []
              }
              values={ongoingSolutionData?.agents}
              handleOnChange={handleAgentSelection}
              onSearchNoResults={(hasNoResults) => {
                setShowNoAgentError(hasNoResults);
              }}
              dropdownLabel="Select/Type to Search"
              clsNames="mas-multiselect-dd-primary mas-multi-dd-2"
              disabled={isLoadingAgents}
            />

            {isLoadingAgents && (
              <CircularProgress
                style={{
                  width: "15px",
                  height: "15px",
                  opacity: 0.8,
                  marginLeft: "5px",
                }}
              />
            )}
          </div>
        </div>
      </section>
    </article>
  );
};

export default DefineSolAgent;
